<template>
  <BaseProgressLinear
    class="FarmSliderProgress"
    :value="startProgress ? 100 : 0"
    :transition-duration="'6s'"
    animation-timing-function="linear"
  />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import BaseProgressLinear from 'Components/Base/BaseProgressLinear.vue';

export default defineComponent({
  name: 'FarmSliderProgress',
  components: {
    BaseProgressLinear,
  },
  setup() {
    const startProgress = ref(false);

    onMounted(() => {
      setTimeout(() => {
        startProgress.value = true;
      }, 300);
    });
    return {
      startProgress,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.progress-linear
  width: 100%
  height: 5px
  background-color: #FFFFFF
  border-radius: 2px
  position: relative
  height: 5px
  z-index: 2
  opacity: 1
</style>
